const BASE_URL = process.env.REACT_APP_BASE_APP_URL;

export default [
  {
    key: 'iam',
    translationKey: 'app.dock.dashboard',
    label: 'Dashboard',
    url: BASE_URL.replace('{app}', 'app'),
    icon: 'home',
  },
  {
    key: 'cat',
    translationKey: 'app.dock.products',
    label: 'Products',
    url: BASE_URL.replace('{app}', 'products'),
    icon: 'tag',
  },
  {
    key: 'spl',
    translationKey: 'app.dock.spooler',
    label: 'Spooler',
    url: BASE_URL.replace('{app}', 'spooler'),
    icon: 'print',
  },
  {
    key: 'pkr',
    translationKey: 'app.dock.picker',
    label: 'Picker',
    url: BASE_URL.replace('{app}', 'picker'),
    icon: 'box-check',
  },
  {
    key: 'cnt',
    translationKey: 'app.dock.cnt',
    label: 'Files',
    url: BASE_URL.replace('{app}', 'files'),
    icon: 'file',
  },
  {
    key: 'qcq',
    translationKey: 'app.dock.quick',
    label: 'Quicq',
    url: BASE_URL.replace('{app}', 'quicq'),
    icon: 'image-polaroid',
  },
  {
    key: 'mes',
    translationKey: 'app.dock.messaging',
    label: 'Messaging',
    url: BASE_URL.replace('{app}', 'messaging'),
    icon: 'comments',
  },
  {
    key: 'wms',
    translationKey: 'app.dock.wms',
    label: 'WMS',
    url: BASE_URL.replace('{app}', 'wms'),
    icon: 'warehouse-alt',
  },
  {
    key: 'rel',
    translationKey: 'app.dock.rel',
    label: 'Contacts',
    url: BASE_URL.replace('{app}', 'contacts'),
    icon: 'address-book',
  },
  {
    key: 'odr',
    translationKey: 'app.dock.order',
    label: 'Orders',
    url: BASE_URL.replace('{app}', 'orders'),
    icon: 'receipt',
  },
  {
    key: 'lcs',
    translationKey: 'app.dock.fulfilment',
    label: 'Fulfilment',
    url: BASE_URL.replace('{app}', 'fulfilment'),
    icon: 'box-check',
  },
];
